import { useId } from '@fluentui/react-hooks';


export function useIdAsTarget(idPrefix) {
  const id = useId(idPrefix);
  const target = `#${id}`;
  return [id, target];
} 
